"use client";

import dynamic from "next/dynamic";
import MapViewLoading from "./map-view-loading";
import { useEffect, useState } from "react";
import styles from "./map-view.module.css";
import { usePageStore } from "../../usePageStore";
import { useLocale, useTranslations } from "next-intl";
import { useListingsCacheStore } from "@/global-cache/useListingsCacheStore";
import { LocationData } from "@/types/types";

const LazyMap = dynamic(() => import("./maplibre/map-libre"), {
  ssr: false,
  loading: () => <MapViewLoading />,
});

export default function MapWrapperClient({
  isMapOpen,
}: {
  isMapOpen: boolean;
}) {
  const [isLoaded, setIsLoaded] = useState(false);
  const showSearchAreaButton = usePageStore(
    (state) => state.showSearchAreaButton,
  );
  const enterFreeMode = usePageStore((state) => state.enterFreeMode);
  const isFullMapView = usePageStore((s) => s.isFullMapView);
  const locale = useLocale();
  const t = useTranslations("SearchResult");
  const setCache = useListingsCacheStore((state) => state.setMultipleListings);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div
      className={`${styles.mapContainerWrapper} ${isFullMapView && styles.fullView}`}
    >
      {showSearchAreaButton && (
        <div className={styles.searchAreaButtonWrapper}>
          <button
            className={styles.searchAreaButton}
            onClick={() => enterFreeMode(locale, setCache)}
          >
            {t("searchThisArea")}
          </button>
        </div>
      )}
      {isLoaded ? <LazyMap isMapOpen={isMapOpen} /> : <MapViewLoading />}
    </div>
  );
}
